import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService } from './../../../../providers';

@Injectable()
export class GridSortService {

  constructor(
    private httpClientService: HttpClientService) { }

  getSortedData(filteredData, sortColumn, sortType) {

    filteredData = filteredData.sort((col1, col2) => {

      if (col1.disableSort === true || (col1.disableSort === true && col2.disableSort === true)) {
        return -1;
      } else if (col2.disableSort === true) {
        return 1;
      }
      col1 = (typeof (col1[sortColumn]) === 'number') ?
        col1[sortColumn] : col1[sortColumn].toLowerCase();
      col2 = (typeof (col2[sortColumn]) === 'number') ?
        col2[sortColumn] : col2[sortColumn].toLowerCase();

      if (sortType.toLowerCase() === 'desc') {
        if (col1 > col2) {
          return -1;
        }

        if (col1 < col2) {
          return 1;
        }

        return 0;
      } else {
        if (col1 > col2) {
          return 1;
        }

        if (col1 < col2) {
          return -1;
        }

        return 0;
      }
    });

    return filteredData;

  }

}
